export const roleAccessForSpare = (authorities) => {
  const value = authorities?.find(
    (item) => item.accessDataTypeName === "Spare Data"
  );
  const readPermission = value.permissionStatusResponseList.find(
    (item) => item.permissionName === "Read"
  );
  const writePermission = value.permissionStatusResponseList.find(
    (item) => item.permissionName === "Write"
  );
  const addDeletePermission = value.permissionStatusResponseList.find(
    (item) => item.permissionName === "Add/Delete"
  );
  return {
    readPermission: readPermission?.active,
    writePermission: writePermission?.active,
    addDeletePermission: addDeletePermission?.active,
  };
};

export const roleAccessForTechnicalDoc = (authorities) => {
  const value = authorities?.find(
    (item) => item.accessDataTypeName === "Technical Document"
  );

  const readPermission = value.permissionStatusResponseList.find(
    (item) => item.permissionName === "Read"
  );
  const writePermission = value.permissionStatusResponseList.find(
    (item) => item.permissionName === "Write"
  );
  const addDeletePermission = value.permissionStatusResponseList.find(
    (item) => item.permissionName === "Add/Delete"
  );
  return {
    readPermission: readPermission?.active,
    writePermission: writePermission?.active,
    addDeletePermission: addDeletePermission?.active,
  };
};

export const roleAccessForAdvisories = (authorities) => {
  const value = authorities?.find(
    (item) => item.accessDataTypeName === "Advisories"
  );

  const readPermission = value.permissionStatusResponseList.find(
    (item) => item.permissionName === "Read"
  );
  const writePermission = value.permissionStatusResponseList.find(
    (item) => item.permissionName === "Write"
  );
  const addDeletePermission = value.permissionStatusResponseList.find(
    (item) => item.permissionName === "Add/Delete"
  );
  return {
    readPermission: readPermission?.active,
    writePermission: writePermission?.active,
    addDeletePermission: addDeletePermission?.active,
  };
};

export const roleAccessForNotifications = (authorities) => {
  const value = authorities?.find(
    (item) => item.accessDataTypeName === "Notifications"
  );

  const readPermission = value.permissionStatusResponseList.find(
    (item) => item.permissionName === "Read"
  );
  const writePermission = value.permissionStatusResponseList.find(
    (item) => item.permissionName === "Write"
  );
  const addDeletePermission = value.permissionStatusResponseList.find(
    (item) => item.permissionName === "Add/Delete"
  );
  return {
    readPermission: readPermission?.active,
    writePermission: writePermission?.active,
    addDeletePermission: addDeletePermission?.active,
  };
};
